var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "preview"
  }, [_c('div', {
    staticClass: "wrap",
    style: _vm.wrapStyle
  }, [_c('canvas', {
    staticClass: "shim",
    attrs: {
      "width": _vm.outerWidth,
      "height": _vm.outerHeight
    }
  }), _c('div', {
    staticClass: "img-pos",
    style: _vm.styleObj
  }, [_c('div', {
    staticClass: "img-rotate",
    style: _vm.rotateStyle
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.src
    },
    on: {
      "load": _vm.imgLoaded
    }
  })])])]), _c('div', {
    staticClass: "placeholder",
    style: _vm.eptStyle
  }, [_vm._t("placeholder")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }